import axios from 'axios';
import React, { useState } from 'react';

import './i18n';
import './App.css';
import LrvForm from './components/LrvForm/LrvForm';
import LrvWelcome from './components/LrvWelcome/LrvWelcome';
import { GOOGLE_FORM_URL, GOOGLE_MEET } from './config/config';
import LrvParticles from './components/LrvParticles/LrvParticles';

const App: React.FC = () => {
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [name, setName] = useState<string>('');

  const handleFormSubmit = async (props: { name: string; email: string; company: string }) => {
    setSubmitted(true);
    setName(props.name);

    const formData = new FormData();
    formData.append('entry.758794219', props.name);
    formData.append('entry.1407251925', props.email);
    formData.append('entry.513774112', props.company);

    try {
      await axios.post(GOOGLE_FORM_URL, formData);
    } catch (error) {
      console.error('Error al enviar datos:', error);
    }

    window.open(GOOGLE_MEET, '_blank', 'width=800,height=600');
  };

  return (
    <div>
      <LrvParticles />
      {!submitted ? (
        <LrvForm onSubmit={handleFormSubmit} />
      ) : (
        <LrvWelcome name={name} />
      )}
    </div>
  );
};

export default App;
